<template>
  <table class="table">
    <thead>
      <tr>
        <th class="is-narrow">
        </th>
        <th v-for="(header, index) in $_.pull(theader, 'id', 'pk')" :key="index" >
          {{ $tc(header) }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(data, index) in tdata" :key="index" @dblclick="$router.push({ path: `${data.pk || data.id}`, append: true })" @click.prevent="select(data)" :class="$_.some(selected, data) && 'is-selected'">
        <!-- кнопка открыть -->
        <td class="is-narrow">
          <router-link :to="`${data.pk || data.id}`" append>
            <span :class="`tag is-${$_.some(selected, data) ? 'white has-text-primary' : 'primary'}`">
              <span class="is-hidden-mobile">Открыть</span>
              <i class="fas fa-link is-hidden-tablet"></i>
            </span>
          </router-link>
        </td>

        <!-- поля -->
        <td v-for="(header, index) in $_.pull(theader, 'id', 'pk')" :key="index" >
          <!-- если поле - массив -->
          <div class="tags" v-if="Array.isArray(data[header])" >
            <router-link class="tag" v-for="(item, index) in data[header]" :key="index" :to="isObject(item, header).link || '#'" title="">{{isObject(item, header).text}}</router-link>
          </div>

          <!-- если поле - булево -->
          <div v-else-if="$_.isBoolean(data[header])" class=" " >
            <span class="icon"><i :class="`fas ${data[header] ? 'fa-check has-text-success' : 'fa-times has-text-danger'}`"></i></span>
          </div>

          <!-- если поле - подпись -->
          <div v-else-if="header === 'sign' && data[header]" class="has-text-centered " >
            <span class="icon has-text-success"><i class="fas fa-check"></i></span>
            <p class="is-size-7">{{$moment(data[header].sign_date).format('D.MM.YY')}}</p>
          </div>

          <!-- если поле - объект -->
          <template v-else-if="$_.isObject(data[header])">
            <router-link
              :to="`/dashboard/${data[header].app}/${(data[header].model || header).replace('_', '')}/${data[header].id || data[header].pk}`"
              :title="`Открыть ${data[header]['__str__'] || data[header].title || data[header].name || data[header].pk || data[header]}`"
              class="icon"
            >
              <i class="fas fa-link  has-text-grey"></i>
            </router-link>
            {{data[header]['__str__'] || data[header].title || data[header].name || data[header].pk || data[header]}}
          </template>

          <!-- для остальных полей -->
          <span v-else >
            {{
              data[header] && header.includes('date') ? $moment(data[header]).format('D.MM.YY, HH:mm') : data[header]
              || '-'
            }}
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  props: {
    theader: Array,
    tdata: Array,
    selected: Array
  },
  methods: {
    select (data) {
      // устанавливает список выбранных ID в массив selected
      const id = this.$_.findIndex(this.selected, data)
      if (id !== -1) {
        this.selected.splice(id, 1)
      } else {
        this.selected.push(data)
      }
      this.$emit('selected', this.selected)
    }
  }
}
</script>
